<div class="pull-left text-muted">
  <i class="fa fa-calendar" aria-hidden="true"></i> <strong>Últimas visitas</strong>
  <i class="icon-info text-muted" aria-hidden="true"
    uib-tooltip="Exibição das últimas localizações dos usuários. Nesta tela são exibidos somentes dados referentes aos últimos 30 dias. Para visualizar outros dados navegue pelo calendário."
    tooltip-placement="bottom" tooltip-append-to-body="true"></i>
</div>
<div class="pull-right text-muted">
  <i class="icon-updated pointer" aria-hidden="true" ng-click="usuarios.refresh()" title="Atualizar"></i>
</div>
<div class="clearfix"></div>

<div class="title text-center">
  <h2>
    <strong>USUÁRIOS</strong>
  </h2>
</div>

<div class="input-group">
  <input type="text"
    autofocus
    class="form-control"
    placeholder="Buscar usuários" ng-model="usuarios.search">
  <span class="input-group-addon">
    <i class="fa fa-search" aria-hidden="true"></i>
  </span>
</div><br>

<uib-accordion close-others="false" class="resumo-users">
  <div uib-accordion-group class="panel-default" ng-repeat="user in usuarios.users | filter:usuarios.search" is-open="user.open">
    <uib-accordion-heading>
      <div ng-click="usuarios.expandUser($event, user)">
        <i class="fa fa-user" aria-hidden="true" ng-style="{color: '#'+user.cor}"></i>
        {{user.nome}} <i class="pull-right fa" ng-class="{'fa-minus-circle': user.open, 'fa-plus-circle': !user.open, 'text-equilibrio': usuarios.isRecent(user), ' text-muted': !usuarios.isRecent(user)}"></i>
      </div>
    </uib-accordion-heading>
    <strong class="title">Talhões visitados em {{user.ultimo_envio | date:'dd/MM'}}</strong>
    <ul class="list-unstyled">
      <li ng-repeat="gleba in user.glebas" class="pointer" uib-tooltip="{{gleba.propriedade.descricao}}"
          tooltip-placement="left" ng-click="usuarios.showTracking(user, gleba)">
        <span class="pull-left">
          <i class="fa fa-spinner fa-spin" ng-show="gleba.loading"></i>
          {{gleba.gleba.descricao | characters: 25}}&nbsp;
          <i class="fa fa-eye" ng-style="{color: gleba.selected && '#' + user.cor}" aria-hidden="true"></i>
        </span>
        <span class="pull-right">às {{gleba.recorded_at | date:'HH:mm'}}</span>
        <div class="clearfix"></div>
      </li>
    </ul>
  </div>
</uib-accordion>
